import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../../../assets/images/logo/Haylo-logo-white.png'
import '../style/style.css'

function MicroSiteDefaultPassword() {
  return (
    <div class="Customer-microsite-default">

      <div class="header default-header">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="header-image text-center py-4">
                <img src={logo} class="img-fluid" alt="logo" style={{ width: "250px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-body mt-4">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <h4 class="content-header text-center pb-2 mb-4">Password Protection.</h4>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-6">
              <div class="gallery-item-view mt-5">
                <div class="password-protection-body">
                  <form>
                    <div class="mb-3">
                      <label for="exampleInputPassword1" class="form-label">Password</label>
                      <input type="password" class="form-control" id="exampleInputPassword1" />
                    </div>
                    <div class="text-right">
                      <button type="submit" class="btn btn-primary">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="micro-site-footer">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <p class="text-center footer-name">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default MicroSiteDefaultPassword
